import { ArticleType, ServiceArticleDetails } from '@nemuru-eng/js-api-client';

import { ServiceFormItem } from '@/components/modules/Application/components/Cart/DefaultCart/components/ArticleTypes/Service/types/ServiceFormItem';
import { Item } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/entities/Item';

export class ServiceItem extends Item<ServiceFormItem> {
  constructor(data: ServiceFormItem) {
    super(data);
  }

  protected isCompleted(): boolean {
    return !!this.data.endDate;
  }

  protected toForm(): ServiceFormItem {
    return {
      ...this.toMinimalFormItem(),
      endDate: this.data.endDate,
    } as ServiceFormItem;
  }

  public static fromOrderLineDto(units: number, article: ServiceArticleDetails): ServiceItem {
    const formData: ServiceFormItem = {
      // Minimal form item fields
      units: units.toString(),
      vat: '21', // FIXME: Default VAT
      price: article.price.amount.toFixed(2).toString(),
      category: article.category,

      // ArticleType-specific fields
      type: ArticleType.SERVICE,
      description: article.description || '',
      endDate: article.endDate as Date,
    };

    return new ServiceItem(formData);
  }

  protected toDto(): object {
    return {
      endDate: this.data.endDate,
    };
  }
}
